export const getSpecialCarContent = async (carsSpecialDesignation) => {
  try {
    const url =
      process.env.VUE_APP_S3_CONFIG_JSON_FILE_URL + "exclusive_car.json";
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("HTTP error, status = " + response.status);
    }
    const jsonData = await response.json();
    return jsonData[carsSpecialDesignation].message.ja;
  } catch (err) {
    console.log('ERROR"" getSpecialCarContent():', err);
    throw err;
  }
};
